import React from 'react'
import { useBanks } from "../../hooks/use-banks"
import { SelectList } from "./select-list"


export const SelectBank = ({ disabled = false }) => {
  const { data: banks, isLoading: isLoadingBanks } = useBanks()

  if (isLoadingBanks) return <div>Cargando...</div>
  if (!banks) return <div>No hay bancos</div>

  return (

    <SelectList
      disabled={disabled}
      name="bank_id"
      label="El nombre del banco donde tienes tu cuenta"
      required
      placeholder="Selecciona un banco"
      options={banks.map((b) => ({ key: b.bank_code, label: b.bank }))}
    />
  )
}